import { render, staticRenderFns } from "./ImportantItems.vue?vue&type=template&id=7ebfaa76&"
import script from "./ImportantItems.vue?vue&type=script&lang=js&"
export * from "./ImportantItems.vue?vue&type=script&lang=js&"
import style0 from "./ImportantItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports